import { isInteger } from 'lodash';

export default function hourIntegerToString (value) {
  let majHour, minHour, majMin, minMin;

  if (!isInteger(value)) return value;

  majHour = Math.floor(value / 1000);
  value -= (majHour * 1000);

  minHour = Math.floor(value / 100);
  value -= (minHour * 100);

  majMin = Math.floor(value / 10);
  value -= (majMin * 10);

  minMin = Math.floor(value / 1);
  value -= (minMin * 1);

  return majHour.toString() + minHour.toString() + ':' + majMin.toString() + minMin.toString();
}



// WEBPACK FOOTER //
// ./src/utils/hours.js